var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"staticpage"},[_c('div',{staticClass:"staticpage_area"},[_c('div',{staticClass:"staticpage_div"},[_c('div',{staticClass:"static_page_title"},[_vm._v(_vm._s(_vm.page_title))]),_c('div',{staticClass:"staticpage_inner_area"},[_c('div',{staticClass:"staticpage_content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }